const YesNoNode = require('../YesNoNode');
const UseAbility = require('../UseAbility');
const Q_status_of_best_target = require('./Q_status_of_best_target');
const Q_tank_between_ally_and_menacer = require('./Q_tank_between_ally_and_menacer');
const Q_nearby_enemies = require('./Q_nearby_enemies');
const BattleCalc = require('../../BattleCalc');

const Q_injured_ally = function (actor, battleState, moveTowards) {
  const node = new YesNoNode(actor, battleState);

  const aggroNode = new Q_status_of_best_target(actor, battleState);

  node.branches[node.YES] = new Q_tank_between_ally_and_menacer(
    actor,
    battleState,
    aggroNode,
    moveTowards
  );
  node.branches[node.NO] = new Q_nearby_enemies(
    actor,
    battleState,
    aggroNode,
    moveTowards
  );

  node.calculateNearestInjuredAlly = function () {
    if (!this.battleState) {
      return null;
    }

    var dist;
    var closestDist = 99;
    var nearestInjuredAlly = null;
    var candidates = [];

    var allies = BattleCalc.getAlliesOfUnit(
      this.actor,
      this.battleState.allUnits,
      true,
      false
    );
    for (var i = 0; i < allies.length; ++i) {
      var ally = allies[i];
      if (ally.hp / ally.max_hp < 0.8) {
        candidates.push(ally);
      }
    }

    for (var i = 0; i < candidates.length; ++i) {
      var candidate = candidates[i];

      dist = BattleCalc.boardDistance(this.actor, candidate);

      if (dist < closestDist) {
        nearestInjuredAlly = candidate;
        closestDist = dist;
      }
    }

    return nearestInjuredAlly;
  };

  node.query = function () {
    // if we're at the end of our turn, do a shield block
    const shieldBlock = BattleCalc.getEquippedAbility(actor, 'shield_block');
    if (shieldBlock && actor.equipment.off_hand?.type === 'shield') {
      const blessedFactor = BattleCalc.getBlessedFactor(actor);
      const shieldBlockCost = shieldBlock.apCost * blessedFactor;
      
      // Simulate resource generation to see what AP we'd have after adrenaline
      const { canAfford, finalAP } = BattleCalc.simulateResourceGeneration(
        actor,
        shieldBlockCost,
        0
      );
      
      // End of turn check: can afford shield_block but not much more
      if (canAfford && finalAP < shieldBlockCost + 10) {
        return new UseAbility({
          actor: this.actor,
          abilityHandle: 'shield_block',
          staticTarget: this.actor,
        }).query(this.actor);
      }
    }

    const injuredAlly = node.calculateNearestInjuredAlly();
    if (injuredAlly) {
      return this.branches[this.YES].query(injuredAlly);
    } else {
      return this.branches[this.NO].query();
    }
  };

  return node;
};
module.exports = Q_injured_ally;
